import React, { createContext, useCallback, useState } from 'react';

import { identifyUser, trackEvent } from 'config/analytics';

const BRAND = 'ShipStation Returns';

export const SegmentContext = createContext({
  identify: () => {},
  track: () => {}
});

export function SegmentProvider({ children = null }) {
  const [identifyUserData, setIdentifyUserData] = useState(null);

  const identify = useCallback(storeProperties => {
    try {
      const userDataString = localStorage.getItem('userData');
      if (!userDataString) {
        return;
      }

      const userData = JSON.parse(userDataString);

      if (!userData || !userData.userId || !storeProperties) {
        return;
      }

      const { userId, firstName, lastName, email } = userData;
      const { name, storeUnquieName } = storeProperties;
      const merchantId = `SSR-${storeUnquieName}`;

      setIdentifyUserData({ userId, merchantId, email });
      identifyUser(userId, {
        group_id: merchantId,
        cx_merchant_id: merchantId,
        customer_id: userId,
        user_id: userId,
        brand: BRAND,
        email,
        first_name: firstName,
        last_name: lastName,
        company_name: name,
        user_role: 'SHOPPER'
      });
    } catch (error) {
      console.error('Failed to identify user in Segment:', error);
    }
  }, []);

  const track = useCallback(
    (eventName, eventProperties) => {
      if (!identifyUserData) return;
      try {
        const { userId, merchantId, email } = identifyUserData;
        trackEvent(eventName, {
          brand: BRAND,
          cx_merchant_id: merchantId,
          user_id: userId,
          email,
          ...eventProperties
        });
      } catch (error) {
        console.error('Failed to track event in Segment:', error);
      }
    },
    [identifyUserData]
  );

  return (
    <SegmentContext.Provider value={{ identify, track }}>
      {children}
    </SegmentContext.Provider>
  );
}
